























import {Component, Vue} from "vue-property-decorator";
import {gQuery} from "@/services/graphql";
import {TablesGQL} from "@dynamoit/shared/src/queries/TablesGQL";
import {TablesForProfile, TablesForProfileVariables} from "@dynamoit/shared/generated/TablesForProfile";

@Component
export default class TablesList extends Vue {

    private filter = ''
    private loading = false
    private tables: string[] = []

    private get profile() {
        return this.$route.params.profile
    }

    private get filteredTables() {
        if (this.filter) {
            return this.tables
                .map(_ => _.toLocaleLowerCase())
                .filter(_ => _.includes(this.filter.toLocaleLowerCase()))
        }
        return this.tables
    }

    private get hint() {
        if (this.filter) {
            return `count ${this.filteredTables.length} of ${this.tables.length}`
        }
        return `count ${this.tables.length}`
    }

    public async mounted(): Promise<void> {
        try {
            this.loading = true
            const result = await gQuery<TablesForProfile, TablesForProfileVariables>(TablesGQL.TABLES_FOR_PROFILE, {
                profileId: this.profile
            })

            this.tables = result.data.tablesForProfile
        } catch (error) {
            //
        } finally {
            this.loading = false
        }
    }

}
